import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { upsertStoreProductReapproParam } from '../mutations/storeProductReapproParams.mutations'
import { fetchStoreProductReapproParams } from '../queries/storeProductReapproParams.queries'
import { REAPPRO_CATEGORY_PREVIEW_KEY } from './reapproCategoryPreview.hooks'

export const useStoreProductReapproParams = (
  storeId: number,
  reapproCategoryId: number,
  enabled = true,
) =>
  useQuery({
    queryKey: ['storeProductReapproParams', storeId, reapproCategoryId],
    queryFn: () => fetchStoreProductReapproParams(storeId, reapproCategoryId),
    enabled,
    staleTime: 30_000,
  })

export const useUpsertStoreProductReapproParam = (storeId: number, reapproCategoryId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: upsertStoreProductReapproParam,
    onSuccess: () => {
      // Réaligne les params sauvegardés ET rafraîchit le preview de la catégorie : la table
      // (ProductsTable) affiche besoin/algo/coef depuis le preview SERVEUR, pas depuis l'override
      // client — sans ce refresh, le besoin affiché resterait périmé après une sauvegarde.
      // C'est UNE requête (preview de cette seule catégorie), pas le recompute /stock lourd
      // (computeStoreMetadata), qui reste évité par le patch ciblé du min-stock.
      void queryClient.invalidateQueries({
        queryKey: ['storeProductReapproParams', storeId, reapproCategoryId],
      })
      void queryClient.invalidateQueries({
        queryKey: [REAPPRO_CATEGORY_PREVIEW_KEY, storeId, reapproCategoryId],
      })
    },
  })
}
